import apiClient from "./apiClient";

export const fetchPromotions = async () => {
    const response = await apiClient.get("/api/promotion/all");
    return response.data;
};

export const fetchShortNews = async () => {
    const response = await apiClient.get("/api/news/all");
    return response.data;
};

export const fetchDetailedNews = async () => {
    const response = await apiClient.get("/api/slider_news/all");
    return response.data;
};

export const fetchPromotionById = async (id) => {
    const response = await apiClient.get(`/api/promotion/${id}`);
    const data = response.data;
    data.type = "promotion";
    return data;
};

export const fetchNewsById = async (id) => {
    const response = await apiClient.get(`/api/slider_news/${id}`);
    const data = response.data;
    data.type = "news";
    return data;
};

export const fetchAboutCompanyGallery = async () => {
    const response = await apiClient.get("/api/about_company");
    return response.data;
};

export const fetchVacancies = async () => {
    const response = await apiClient.get("/api/vacancies/all");
    return response.data;
};

export const fetchSocialActivities = async () => {
    const response = await apiClient.get("/api/social_activity/all");
    return response.data;
};

export const fetchStations = async () => {
    const response = await apiClient.get("/api/gas_stations/all");
    return response.data;
};

export const fetchUsefulInformation = async () => {
    const response = await apiClient.get("/api/useful_information/all");
    return response.data;
};

export const fetchZakupki = async () => {
    const response = await apiClient.get("/api/zakupki/all");
    return response.data;
};

export const fetchFuelPrices = async () => {
    const response = await apiClient.get("/api/fuel_prices/all");
    return response.data;
};
